"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriorAuthDocumentTypeEnumToJSON = exports.PriorAuthDocumentTypeEnumFromJSONTyped = exports.PriorAuthDocumentTypeEnumFromJSON = exports.PriorAuthDocumentTypeEnum = void 0;
/**
 *
 * @export
 */
exports.PriorAuthDocumentTypeEnum = {
    Invoice: 'invoice',
    PapFapApplication: 'pap_fap_application',
    ScannedReqForm: 'scanned_req_form',
    Report: 'report',
    LetterOfMedicalNecessity: 'letter_of_medical_necessity',
    InsuranceCard: 'insurance_card',
    Other: 'other',
    FamilyHistory: 'family_history',
    PreviousResults: 'previous_results',
    ScannedReqFormImage: 'scanned_req_form_image',
    InsurancePaperwork: 'insurance_paperwork',
    Waiver: 'waiver',
    SecInsuranceCard: 'sec_insurance_card',
    GeneticCounseling: 'genetic_counseling',
    ReportCoverSheet: 'report_cover_sheet',
    MedicalRecords: 'medical_records',
    PatientMedicalRecord: 'patient_medical_record',
    CollaborationForm: 'collaboration_form',
    OnlineRequisitionForm: 'online_requisition_form',
    PaymentReceipt: 'payment_receipt',
    SampleFailureLetter: 'sample_failure_letter',
    ManagementGuideline: 'management_guideline',
    AllPaperwork: 'all_paperwork',
    GiaTranscript: 'gia_transcript',
    GiaResultsTranscript: 'gia_results_transcript',
    CreditCardAuthorizationForm: 'credit_card_authorization_form',
    CarrierCouplesSummary: 'carrier_couples_summary',
    PersonalizedPrescribingReport: 'personalized_prescribing_report',
    FfpeSpecimenRequestForm: 'ffpe_specimen_request_form',
    PatientSummaryLetter: 'patient_summary_letter',
    PathologyReport: 'pathology_report',
    PreliminaryReport: 'preliminary_report',
    DrugGeneSummary: 'drug_gene_summary',
    ResidualRiskTable: 'residual_risk_table',
    PayorSpecificPriorAuthorizationForm: 'payor_specific_prior_authorization_form',
    ClinicalNotesSupportingMedicalNecessityForGeneticTesting: 'clinical_notes_supporting_medical_necessity_for_genetic_testing'
};
function PriorAuthDocumentTypeEnumFromJSON(json) {
    return PriorAuthDocumentTypeEnumFromJSONTyped(json, false);
}
exports.PriorAuthDocumentTypeEnumFromJSON = PriorAuthDocumentTypeEnumFromJSON;
function PriorAuthDocumentTypeEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.PriorAuthDocumentTypeEnumFromJSONTyped = PriorAuthDocumentTypeEnumFromJSONTyped;
function PriorAuthDocumentTypeEnumToJSON(value) {
    return value;
}
exports.PriorAuthDocumentTypeEnumToJSON = PriorAuthDocumentTypeEnumToJSON;
